import { render, staticRenderFns } from "./reference-clients-data-table.vue?vue&type=template&id=5553807f&scoped=true&"
import script from "./reference-clients-data-table.vue?vue&type=script&lang=js&"
export * from "./reference-clients-data-table.vue?vue&type=script&lang=js&"
import style0 from "./reference-clients-data-table.vue?vue&type=style&index=0&id=5553807f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553807f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5553807f')) {
      api.createRecord('5553807f', component.options)
    } else {
      api.reload('5553807f', component.options)
    }
    module.hot.accept("./reference-clients-data-table.vue?vue&type=template&id=5553807f&scoped=true&", function () {
      api.rerender('5553807f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reference-clients/reference-clients-data-table.vue"
export default component.exports